import React, { lazy, useEffect, useState } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import * as EnvConstants from "../src/Constants/EnvConstants";
import { QueryStringProvider } from "./Contexts/QueryString";
import { VisitorParamsProvider } from "./Contexts/VisitorParams";
import { queryString } from "./Utility/QueryString";
import "./App.scss";
import { RedirectProvider } from "./Contexts/RedirectContext";
import { ReferenceProvider } from "./Contexts/ReferenceContext";

// const AllRoutes =  lazy(() => import("./Routes/AllRoutes"));
const Unqualified = lazy(() => import('./Components/Pages/Unqualified'));
const FbPixel = lazy(() => import('./Components/Pages/FbPixel'));
const HomePage = lazy(() => import('./Components/Pages/HomePage'));
const UFC_DC_V4_Routes = lazy(() => import("./Routes/UFC_DC_V4_Routes"));
const AdtopiaLoadDynamic = lazy(() => import('./Utility/AdtopiaLoadDynamic'));
const ThankyouBL = lazy(() => import('./Components/Pages/ThankyouBL'));
const NotFound1 = lazy(() => import('./Components/Pages/NotFound1'));
const NotFound = lazy(() => import('./Components/Pages/NotFound'));

const App = () => {
  const [visitorParameters] = useState({ visitor_parameters: [], data: [] });
  const [redirectUrl] = useState({ redirectUrl: '' });
  useEffect(() => {
    document.title = EnvConstants.AppTitle;
  }, []);
  const [referenceID, setReferenceID] = useState("");
  return (
    <>
      <VisitorParamsProvider value={{ visitorParameters }}>
        <QueryStringProvider value={{ queryString }}>
          <RedirectProvider value={{ redirectUrl }}>
          <ReferenceProvider value={{ referenceID,setReferenceID }}>
            <BrowserRouter>
              <React.Suspense fallback={<div style={{ color: '#FFFFFF' }}>Loading...</div>}>
              {/* <AllRoutes /> */}
              <Route exact path="/" component={HomePage} />
              <Route exact path="/unqualified" component={Unqualified} />
              <Route exact path="/fbpixel" component={FbPixel} />
              <Route exact path={['/google', '/testing']} component={AdtopiaLoadDynamic} />
              <Route exact path="/thankyou-bl" component={ThankyouBL} />
              <Route exact path={["/Not_Found"]} component={NotFound1} />
              <Route exact path={["/404"]} component={NotFound} />
              
              <UFC_DC_V4_Routes />
    
              </React.Suspense>
             </BrowserRouter>
             </ReferenceProvider>
          </RedirectProvider>
        </QueryStringProvider>
      </VisitorParamsProvider>
    </>
  );
};

export default App;
